import { Pipe, PipeTransform } from '@angular/core';
import { CxDatePipe, LanguageService } from '@spartacus/core';
import { Observable, of } from 'rxjs';

@Pipe({
  name: 'sdDeliverIn',
  standalone: false,
})
export class DeliverInPipe implements PipeTransform {
  constructor(private language: LanguageService) {}

  transform(rawDate: Date | string, format = 'dd.MM'): Observable<string> {
    const now = Date.now();
    const oneDay = 24 * 60 * 60 * 1000;
    const date = typeof rawDate === 'string' ? new Date(rawDate) : rawDate;

    const isToday = new Date(now).getDate() === date.getDate() && Math.abs(now - +date) <= oneDay;
    const isTomorrow = new Date(now + oneDay).getDate() === date.getDate() && Math.abs(now - +date) <= 2 * oneDay;

    const isAfterTomorrow =
      new Date(now + 2 * oneDay).getDate() === date.getDate() && Math.abs(now - +date) <= 3 * oneDay;

    if (isToday) {
      return of('сегодня');
    }

    if (isTomorrow) {
      return of('завтра');
    }

    if (isAfterTomorrow) {
      return of('послезавтра');
    }

    return of(new CxDatePipe(this.language).transform(date, format));
  }
}
